import { render, staticRenderFns } from "./zrbhdMsg.vue?vue&type=template&id=4d4de5a2&"
import script from "./zrbhdMsg.vue?vue&type=script&lang=js&"
export * from "./zrbhdMsg.vue?vue&type=script&lang=js&"
import style0 from "./zrbhdMsg.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports